module.exports = __webpack_public_path__ + "static/media/new_shortcut_label.c08491b2.png";